import { DATA_STATES } from '@/store/consts';

const STATE_KEYS = {
  DATA_STATE: 'dataState',
  WORKATO_TOKEN_NEED_TO_REFRESH: 'workatoTokenNeedToRefresh',
  WORKATO_TOKEN: 'workatoToken',
  WORKATO_CONFIG_VALUES: 'workatoConfigValues',
  WORKATO_RECIPE: 'workatoRecipe',
  WORKATO_RECIPE_LOAD_STATE: 'workatoRecipeLoadState',
  WORKATO_ADMINS: 'workatoAdmins',
  EXISTING_WORKATO_ACCOUNT: 'existingWorkatoAccount',
  EXISTING_WORKATO_USER: 'existingWorkatoUser',
  NEW_WORKATO_USER: 'newWorkatoUser',
  NEW_WORKATO_ACCOUNT: 'newWorkatoAccount',
  LAST_UPDATE_TIME: 'lastUpdateTime',
  ERROR_COUNT: 'errorCount',
  DO_NOT_SHOW_PRE_BUILD_RECIPES_MODAL: 'doNotShowPreBuildRecipeModal',
};

const state = {
  [STATE_KEYS.DATA_STATE]: DATA_STATES.NONE,
  [STATE_KEYS.WORKATO_TOKEN]: {},
  [STATE_KEYS.WORKATO_TOKEN_NEED_TO_REFRESH]: true,
  [STATE_KEYS.WORKATO_CONFIG_VALUES]: {},
  [STATE_KEYS.WORKATO_RECIPE]: {},
  [STATE_KEYS.WORKATO_RECIPE_LOAD_STATE]: DATA_STATES.NONE,
  [STATE_KEYS.WORKATO_ADMINS]: {},
  [STATE_KEYS.EXISTING_WORKATO_ACCOUNT]: {},
  [STATE_KEYS.EXISTING_WORKATO_USER]: {},
  [STATE_KEYS.NEW_WORKATO_USER]: {},
  [STATE_KEYS.LAST_UPDATE_TIME]: null,
  [STATE_KEYS.ERROR_COUNT]: 0,
  [STATE_KEYS.DO_NOT_SHOW_PRE_BUILD_RECIPES_MODAL]: {
    created: false,
    value: false,
  },
};

export {
  state,
  STATE_KEYS,
};
